import { TokenCoreBase } from "./token.core.base"


export class TokenCore extends TokenCoreBase {

}